/**
 *所有原生直接调H5的方法都封装在 window.__xgj__H5ToNative__callback__ 这个对象下
 *现在有如下方法：
 *clickBack => 点击返回键时调用
 *voicePlayEnd => 在原生语音播放完毕时调用
 *voiceRecordEnd => 在原生录音自动停止时调用
 */

import base from '@m-common/utils/base.js'

let fnNames = [
    'chooseImage',
    'previewImages',
    'chooseVideo',
    'compressorVideo',
    'playVideo',
    'startRecord',
    'stopRecord',
    'playVoice',
    'pauseVoice',
    'stopVoice',
    'uploadImage',
    'uploadVoice',
    'uploadVideo',
    'closeWindow',
    'goBack',
    'setAppTitle',
    'getFutureCloudToken',
    'showOptionMenu',
    'updateAppMessageShareData',
    'updateTimelineShareData',
    'changeUser',
    'loginOut',
    'clearWebCache',
    'goMessageCenter',
    // 原生提供的暴露给H5的跳转到相应原生界面的方法。
    'goActivity',
    // 原生提供的取消压缩的方法
    'cancelCompress',
    // 原生提供的取消上传的方法
    'cancelUpload',
    // 原生提供二维码扫描方法
    'qrcodeScan',
    // 原生提供获取原生的token方法
    'getAppToken',
    // 原生提供的导出课表到本机的日历上
    'insertCalendar',
    // 原生提供的拍照并上传接口（当前应用于人脸识别场景）
    'takePhoto',
    'openNewWindow',
    'saveFile',
    'AppPurchase'
]

var xah = (window.xah = {})
var cb = {}

window.__xgj__H5ToNative__callback__ = cb
Vue.event = new Vue()
window.clickBack = cb.clickBack = function clickBack() {
    Vue.event.$emit('appGoBack')
}

Vue.event.$on('appGoBack', function () {
    xgj.goBack()
})

// 提供给原生调用(在原生语音播放完毕时会调用)
cb.voicePlayEnd = function voicePlayEndHandler(res) {
    // alert('原生调用h5 => 语音播放完毕');
    cb.ovpeHandler && cb.ovpeHandler(res)
}
// 用于监听语音播放完毕, SDK提供给应用层调用
xah.onVoicePlayEnd = function (opt) {
    cb.ovpeHandler = opt.complete
}

// 提供给原生调用(在原生录音自动停止时会调用)
cb.voiceRecordEnd = function voiceRecordEndHandler(res) {
    // alert('原生调用h5 => 录音自动停止');
    cb.vrHandler && cb.vrHandler(res)
}
// 用于监听录音自动停止, SDK提供给应用层调用
xah.onVoiceRecordEnd = function (opt) {
    cb.vrHandler = opt.complete
}

if (base.env === 'xgj') {
    const shareName = '__protocal' + Date.now() + '__'

    let idCount = 0

    function createID() {
        return Date.now() + '$' + idCount++
    }

    const send = (function () {
        let pool = {}

        window[shareName] = function exec(id) {
            let fn = pool[id]
            //delete pool[id];        //一次性.
            return fn
        }

        return function (fn) {
            let id = createID()
            pool[id] = fn
            return [`window.${shareName}('${id}')`, () => delete pool[id]] //exec(id)(...)
        }
    })()

    const codeMap = {
        '0': 'success',
        '1': 'fail',
        '2': 'cancel',
        '3': 'progress' //查询进度
    }

    function wxApi(appRequest) {
        return function (opt) {
            let delFn = null //回调函数清理

            function callback(res) {
                // if (!codeMap[res.code]){
                //     throw new Error('错误状态码:' + res.code);
                // }
                let fnName = codeMap[res.code + '']
                opt[fnName] && opt[fnName](res.data)
                if (res.code != 3) {
                    //如果是查询进度，不调用complete
                    opt.complete && opt.complete(res)
                    delFn()
                }
            }

            if (opt && typeof opt === 'object') {
                ;[opt.result, delFn] = send(callback)
                window.xgj[appRequest](opt && JSON.stringify(opt))
            } else {
                window.xgj[appRequest]()
            }
        }
    }

    fnNames.forEach(fnname => {
        if (base.isWKWebview === true) {
            if (typeof xgj === 'undefined') {
                window.xgj = {}
            }
            Object.defineProperty(window.xgj, fnname, {
                get: function () {
                    return function (params) {
                        window.webkit.messageHandlers[fnname].postMessage(params)
                    }
                }
            })
        }

        xah[fnname] = wxApi(fnname)
    })
}

export default xah
